import { rememberOpenFilterMenu, restoreOpenFilterMenu } from "packs/backoffice-participants-filter-menu-persist"
import { refreshParticipantsLive } from "packs/backoffice-participants-live-refresh"

const closeStatusMenu = (root) => {
  const trigger = root.querySelector("[data-participants-status-filter-trigger]")
  const menu = root.querySelector("[data-participants-status-filter-menu]")
  const pill = root.querySelector(".backoffice-participants-inscription-filter__pill")
  if (!trigger || !menu) return

  menu.hidden = true
  trigger.setAttribute("aria-expanded", "false")
  trigger.classList.remove("is-open")
  if (pill) pill.classList.remove("is-open")
}

const openStatusMenu = (root) => {
  const trigger = root.querySelector("[data-participants-status-filter-trigger]")
  const menu = root.querySelector("[data-participants-status-filter-menu]")
  const pill = root.querySelector(".backoffice-participants-inscription-filter__pill")
  if (!trigger || !menu) return

  menu.hidden = false
  trigger.setAttribute("aria-expanded", "true")
  trigger.classList.add("is-open")
  if (pill) pill.classList.add("is-open")
}

const syncStatusFields = (root, form) => {
  const param = root.dataset.participantsStatusParam
  if (!param || !form) return

  form.querySelectorAll(`input[data-participants-status-hidden="${param}"]`).forEach((input) => {
    input.remove()
  })

  const checked = root.querySelectorAll("[data-participants-status-option]:checked")
  if (checked.length === 0) {
    // Marqueur pour que le serveur sache que la sélection vide est volontaire
    // (sinon absence de param → valeurs par défaut).
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = `${param}[]`
    input.value = ""
    input.dataset.participantsStatusHidden = param
    form.appendChild(input)
    return
  }

  checked.forEach((checkbox) => {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = `${param}[]`
    input.value = checkbox.value
    input.dataset.participantsStatusHidden = param
    form.appendChild(input)
  })
}

const applyStatusFilter = async (root, form) => {
  syncStatusFields(root, form)
  const param = root.dataset.participantsStatusParam
  if (param) rememberOpenFilterMenu("status", param)
  const ok = await refreshParticipantsLive(form)
  // Menu déjà ouvert : inutile de restaurer au prochain chargement.
  if (ok) sessionStorage.removeItem("backoffice-participants-filter-menu-open")
}

const closeOtherStatusMenus = (current) => {
  document.querySelectorAll("[data-participants-status-filter]").forEach((root) => {
    if (root === current) return
    closeStatusMenu(root)
  })
  document.querySelectorAll("[data-participants-catalogue-filter]").forEach((node) => {
    const otherTrigger = node.querySelector("[data-participants-catalogue-filter-trigger]")
    const otherMenu = node.querySelector("[data-participants-catalogue-filter-menu]")
    const otherPill = node.querySelector(".backoffice-participants-catalogue-filter__pill")
    if (!otherTrigger || !otherMenu) return
    otherMenu.hidden = true
    otherTrigger.setAttribute("aria-expanded", "false")
    otherTrigger.classList.remove("is-open")
    if (otherPill) otherPill.classList.remove("is-open")
  })
}

const bindStatusFilter = (root) => {
  if (root.dataset.bound === "true") return
  root.dataset.bound = "true"

  const trigger = root.querySelector("[data-participants-status-filter-trigger]")
  const menu = root.querySelector("[data-participants-status-filter-menu]")
  const form =
    document.querySelector("form[data-participants-status-filter-form]") ||
    document.querySelector("form[data-auto-search]")
  if (!trigger || !menu || !form) return

  trigger.addEventListener("click", (event) => {
    event.preventDefault()
    event.stopPropagation()
    closeOtherStatusMenus(root)
    if (menu.hidden) {
      openStatusMenu(root)
    } else {
      closeStatusMenu(root)
    }
  })

  menu.querySelectorAll("[data-participants-status-option]").forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      applyStatusFilter(root, form)
    })
  })

  const selectAll = menu.querySelector("[data-participants-status-select-all]")
  const selectNone = menu.querySelector("[data-participants-status-select-none]")
  const options = () => menu.querySelectorAll("[data-participants-status-option]")

  if (selectAll) {
    selectAll.addEventListener("click", (event) => {
      event.preventDefault()
      event.stopPropagation()
      options().forEach((checkbox) => {
        checkbox.checked = true
      })
      applyStatusFilter(root, form)
    })
  }

  if (selectNone) {
    selectNone.addEventListener("click", (event) => {
      event.preventDefault()
      event.stopPropagation()
      options().forEach((checkbox) => {
        checkbox.checked = false
      })
      applyStatusFilter(root, form)
    })
  }

  menu.addEventListener("click", (event) => {
    event.stopPropagation()
  })
}

const initBackofficeParticipantsStatusFilters = () => {
  document.querySelectorAll("[data-participants-status-filter]").forEach(bindStatusFilter)
  restoreOpenFilterMenu()
}

document.addEventListener("click", () => {
  document.querySelectorAll("[data-participants-status-filter]").forEach((root) => {
    closeStatusMenu(root)
  })
})

document.addEventListener("turbolinks:before-cache", () => {
  document.querySelectorAll("[data-participants-status-filter]").forEach((root) => {
    closeStatusMenu(root)
    root.dataset.bound = "false"
  })
})

export { initBackofficeParticipantsStatusFilters }
